module.exports = __webpack_public_path__ + "static/img/tabsBg.60f48c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabsBg.png
// module id = Ckpr
// module chunks = 18